/* Multi-checkbox field for masters (e.g. sections inside a class). */
import { useEffect, useState } from "react";

export function MultiCheck({ value = [], onChange, options, testid, columns = 4 }) {
  const v = Array.isArray(value) ? value : [];
  const toggle = (opt) => onChange?.(v.includes(opt) ? v.filter((x) => x !== opt) : [...v, opt]);
  return (
    <div className={`grid grid-cols-2 md:grid-cols-${columns} gap-1.5`} data-testid={testid}>
      {options.map((o) => {
        const lbl = typeof o === "string" ? o : o.label;
        const val = typeof o === "string" ? o : o.value;
        const checked = v.includes(val);
        return (
          <label
            key={val}
            className={`flex items-center gap-2 px-2 py-1.5 rounded border text-xs cursor-pointer transition ${
              checked ? "border-[var(--erp-primary)] bg-[var(--erp-primary)]/5 erp-text-primary font-semibold" : "border-slate-200 hover:bg-slate-50"
            }`}
            data-testid={`${testid}-opt-${val}`}
          >
            <input type="checkbox" checked={checked} onChange={() => toggle(val)} className="w-3.5 h-3.5" />
            <span className="truncate">{lbl}</span>
          </label>
        );
      })}
    </div>
  );
}
